var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import DateProvider from './DateProvider';
/**
 * @deprecated
 * Use `DateInput` to render a date field
 */
export function DateInputComponent(props) {
    return React.createElement(DateProvider, __assign({ Input: KeyboardDatePicker }, props));
}
DateInputComponent.defaultProps = {
    format: 'dd/MM/yyyy',
};
export default DateInputComponent;
//# sourceMappingURL=DateInput.js.map